<template>
  <div class="invite-rules-root" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Rules -->
          <span class="tit-left">{{ $t('lang.BaseModule.k075') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="rules-content">
      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title">{{ $t('lang.HostessIncomeRank.k003') }}</p>
        <p class="rules-row">1. {{ $t('lang.HostessIncomeRank.k004') }}</p>
        <MyPLabel class="rules-row" :str="`2. ${$t('lang.HostessIncomeRank.k005')}`" :numsOption="[{ value: time }]" />
        <MyPLabel class="rules-row" :str="`3. ${$t('lang.HostessIncomeRank.k008')}`" :numsOption="[{ value: time }]" />
      </div>

      <div class="rules-block" style="letter-spacing: -0.5px">
        <p class="rules-title">{{ $t('lang.HostessIncomeRank.k006') }}</p>
        <p class="rules-row">1. {{ $t('lang.HostessIncomeRank.k007') }}</p>
        <MyPLabel class="rules-row" :str="`2. ${$t('lang.HostessIncomeRank.k005')}`" :numsOption="[{ value: time }]" />
        <MyPLabel class="rules-row" :str="`3. ${$t('lang.HostessIncomeRank.k008')}`" :numsOption="[{ value: time }]" />
      </div>
    </div>
  </div>
</template>

<script>
import { getBaseFeature } from '@/assets/style/variable'
export default {
  data() {
    return {
      time: '',
    }
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
  },
  created() {
    // 排行榜规则刷新时间给默认值（utc-10的0点对应当地时间）
    const utcTimestamp = new Date(Date.UTC(new Date().getFullYear(), 0, 1, 0, 0, 0, 10 * 3600000))
    const localDate = new Date(utcTimestamp)
    this.time = `${String(localDate.getHours()).padStart(2, '0')}:${String(localDate.getMinutes()).padStart(2, '0')}`
  },
}
</script>

<style lang="scss" scoped>
.invite-rules-root {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .van-bar-block {
    background: #f9f9fb;
  }
  .rules-content {
    flex: 1;
    width: 100%;
    background-color: #f9f9fb;
    overflow-y: scroll;
  }
  .rules-block {
    background-color: #ffffff;
    padding: 16px 24px;
    margin-bottom: 10px;
    .deliver-line {
      width: 327px;
      height: 1px;
      margin: 0 auto;
      transform: rotateX(45deg);
      background: #ededed;
    }
  }
  .rules-title {
    font-family: var(--string-font);
    font-size: var(--fs-16);
    font-weight: var(--fw-700);
    line-height: var(--lh-body-24);
    color: #333333;
    width: 100%;
    text-align: center;
    padding: 16px 0 24px;
  }
  .rules-row {
    font-family: var(--string-font);
    font-size: var(--fs-16);
    font-weight: var(--fw-400);
    color: #333333;
    line-height: var(--lh-body-24);
    margin-bottom: 12px;
    letter-spacing: -0.5px;
    .beans-img {
      width: 18px;
      height: 18px;
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>

<style lang="scss">
.invite-rules-root {
  .custom-nav-block {
    background-color: #f9f9fb;
  }
  .van-nav-bar {
    .van-nav-bar__content {
      .van-nav-bar__left {
        .left-nav {
          width: 20px;
          height: 20px;
        }
        .tit-left {
          font-weight: var(--fw-400);
          line-height: var(--lh-headline-28);
        }
      }
    }
  }
}
</style>
